import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import type { ReportParameterConfig } from '../../PageConfigProvider/page-reducer';
import { ParameterEditor } from './ParameterEditor';
import { determinePrimaryParameter, parametersAreValid } from './parameters';

export function ReportParametersModal({
  isOpen,
  onClose,
  defaultValue,
  onSave,
}: {
  isOpen: boolean;
  onClose: () => void;
  defaultValue?: ReportParameterConfig[];
  onSave: (params: ReportParameterConfig[] | undefined) => void;
}) {
  const toast = useToast();
  const [parameters, setParameters] = useState<ReportParameterConfig[]>(
    defaultValue ?? []
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: migrated from develop
  useEffect(() => {
    setParameters(defaultValue ?? []);
  }, [defaultValue, isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="text.primary">
          Configure Report Parameters
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing={6}>
            <ParameterEditor parameters={parameters} onChange={setParameters} />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            colorScheme="navyBlue"
            variant="ghost"
            onClick={onClose}
            mr={2}
          >
            Close
          </Button>
          <Button
            size="sm"
            colorScheme="green"
            mr={2}
            onClick={() => {
              const parametersWithPrimary =
                determinePrimaryParameter(parameters);
              const validation = parametersAreValid(parametersWithPrimary);
              if (validation.isValid) {
                onSave(parametersWithPrimary);
                onClose();
              } else {
                toast({
                  title: 'Invalid parameter configuration',
                  description: validation.reason,
                  status: 'error',
                });
              }
            }}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
